import styled from 'styled-components'

export const Container = styled.div`
    padding: 20px;
    .actions {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .right-side {
            display: flex;
            align-items: center;
            gap: 10px;
        }
        @media (min-width: 820px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0;
        }

        /* a {
      color: #fff;
      text-transform: uppercase;
      background: #1976d2;
      padding: 8px 10px;
      border-radius: 6px;
      font-family: "Roboto","Helvetica","Arial",sans-serif;
      font-weight: 500;
      font-size: 0.875rem;
      letter-spacing: 0.02857em;
      box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
      display: flex;
      align-items: center;
      gap: 4px;
      width: max-content;
    } */
    }
`

export const Title = styled.div`
    /* margin-bottom: 20px; */
    h1 {
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
    }

    p {
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
        font-size: 14px;
    }
`

export const Period = styled.ul`
    display: flex;
    align-items: center;
    background: #fff;
    width: max-content;
    /* border: 1px solid #D3D3D3; */
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-radius: 8px;
    margin: 20px 0;
    overflow: hidden;
    li {
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 400;
        /* color: #333; */

        padding: 10px 12px;
        cursor: pointer;
        &:hover {
            opacity: 0.8;
        }
    }

    li.selected {
        background: rgba(0, 0, 0, 0.08);
    }

    li:not(:last-child) {
        border-right: 1px solid #d3d3d3;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (min-width: 1200px) {
        flex-direction: row;
        justify-content: space-between;
    }
`

export const Main = styled.div`
    padding: 10px;
    background: #fff;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    height: max-content;
    width: 100%;
    .chart {
        background: green;
    }
`

export const Cards = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: 600px) {
        flex-direction: row;
        align-items: center;
    }
    gap: 40px;
    margin-bottom: 30px;

    .card {
        display: flex;
        align-items: center;
        background: #fff;
        padding: 10px;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
            rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        width: 100%;
        height: 150px;
        .details {
            padding: 10px 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3 {
                font-family: 'Inter';
                font-size: 18px;
                font-weight: 500;
                color: #333;
            }
        }

        .balance {
            p:first-child {
                font-family: 'Inter';
                font-size: 13px;
                margin-bottom: 10px;
                color: #333;
            }

            p:last-child {
                font-family: 'Inter';
                font-size: 22px;
                font-weight: 500;
            }
        }
    }
`

export const Aside = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* max-width: 700px; */
`

export const Box = styled.div`
    /* padding: 0 10px; */
    background: #fff;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    width: 100%;
    overflow: hidden;

    .title {
        padding: 14px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #d3d3d3;

        a {
            font-family: 'Inter';
            font-weight: 500;
            color: #333;
            font-size: 16px;

            &:hover {
                text-decoration: underline;
                text-underline-offset: 1px;
                color: #4c83ee;
            }
        }

        .description {
            font-size: 13px;
            font-family: 'Inter';
            color: #333;
        }
    }
`

export const ContractsList = styled.ul`
    max-height: 287px;
    overflow: auto;
    /* padding: 0 10px; */
    ::-webkit-scrollbar {
        width: 4px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }

    li {
        padding: 8px 10px;
        display: flex;
        align-items: center;
        gap: 25px;
        font-family: 'Roboto';
        font-size: 14px;
        cursor: pointer;

        &:hover {
            background: rgba(0, 157, 221, 0.1);
        }
        p:first-child {
            font-weight: 500;
        }

        p:last-child {
            font-size: 12px;
        }

        .value {
            font-family: 'Roboto';
            font-weight: 600;
            color: #2e7d32;
            margin-left: auto;

            &.negative {
                color: red;
            }
        }
    }

    li:not(:last-child) {
        border-bottom: 1px solid #d3d3d3;
    }
`

export const Sent = styled.div``
